import computed from './attrs/computed'
import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'

export default {
    name: 'ProfessionalFinderProfile',
    computed,
    data,
    methods,
    mounted
}
